//default from angular libraries
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

//import settings
import { AppSettings } from '../../../constants/app-settings';
import { AppFrontRoutes } from '../../../constants/app-front-routes';

//import services
import { GeneralService } from '../../../services/general.service';
import { AuthService } from '../../../services/auth.service';

//classes
import { LoginInputCls } from '../../../classes/login/login_input';
import { LoginOutputCls } from '../../../classes/login/login_output';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})

export class LoginComponent implements OnInit {

    readonly AppSettings = AppSettings;

    loginForm: FormGroup;
    submitted = false;
    Logininput: LoginInputCls;
    
  	login_validation_messages = {
  		'username': [
  		  { type: 'required', message: 'Email is required' },
  		  { type: 'email', message: 'Enter a valid email' }
  		],
  		'password': [
  		  { type: 'required', message: 'Password is required' },
  		],
  	}


  	constructor(
          private router: Router,
          private formBuilder: FormBuilder,
          private generalService: GeneralService,
          private authService: AuthService,
    ) { }

  	ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['demo@kaizencloud.eu', [Validators.required, Validators.email]],
            password: ['kaizencloud', [Validators.required]],
        });
    }

   	get f() { return this.loginForm.controls; }

   	onSubmit() {

        this.submitted = true;
           
        // stop here if form is invalid
        if (this.loginForm.invalid)
            return;
        
        this.Logininput = this.loginForm.value;

        this.login();
        
    }

    login() {

        this.authService.login(this.Logininput)
        .subscribe(
            (res : LoginOutputCls) => {
                if(res.status){
                    this.generalService.notify_msg('success', res.msg);
                    this.router.navigate([AppFrontRoutes.DASHBOARD]);
                    localStorage.setItem('super_user', "0");
                    localStorage.setItem('lang', res.data.lang);
                }
                else{
                    this.loginForm.reset();
                    this.submitted = false;
                    this.generalService.notify_msg('error', res.msg);
                    localStorage.setItem('super_user', "0");
                    localStorage.setItem('lang', "english");
                }
            },
            (err : any) => {
                this.loginForm.reset();
                this.submitted = false;
                this.generalService.notify_msg('error', err.error.msg);
                localStorage.setItem('super_user', "0");
                localStorage.setItem('lang', "english");
            }
        );

    }

}
